import type { ErrorTranslations } from "./utils";

export default {
  not_found: {
    EN: "Institution not found",
    RO: "Instituția nu a fost găsită",
  },
  no_enabled_forms: {
    EN: "Institution has no enabled forms",
    RO: "Instituția nu are formulare activate",
  },
  slug_already_exists: {
    EN: "Another institution with the same name already exists",
    RO: "O altă instituție cu același nume există deja",
  },
} satisfies ErrorTranslations;
